export default __webpack_public_path__ + "static/media/mary.56af507a.svg";